import { CUSTOM_CHANNEL } from '@disco/constants/GroupTypes'
import type { Group } from 'types/group'

import { sortAlphabetically } from '@disco/utils/sorting'

export function getCatalogConnectChannels(
  items: Record<number, Group> | Record<string, Group>,
): Group[] {
  return (Object.values(items) as Group[])
    .filter((group: Group) => group.group_type === CUSTOM_CHANNEL)
    .sort(sortAlphabetically)
}
